/**
 * ShortcutsHelp — keyboard shortcuts help overlay.
 * Opens when user presses '?'.
 */

import React from 'react';

interface ShortcutsHelpProps {
  open: boolean;
  onClose: () => void;
}

const SHORTCUTS = [
  { keys: ['Ctrl', 'K'], desc: 'Search & navigate' },
  { keys: ['G', 'D'], desc: 'Go to CFO Dashboard' },
  { keys: ['G', 'E'], desc: 'Go to Activity Tracker' },
  { keys: ['G', 'W'], desc: 'Go to Workflows' },
  { keys: ['G', 'R'], desc: 'Go to Financial Reports' },
  { keys: ['G', 'C'], desc: 'Go to Command Center' },
  { keys: ['G', 'O'], desc: 'Go to Operations' },
  { keys: ['G', 'A'], desc: 'Go to Analytics' },
  { keys: ['?'], desc: 'Show this help' },
  { keys: ['Esc'], desc: 'Close panel' },
];

export const ShortcutsHelp: React.FC<ShortcutsHelpProps> = ({ open, onClose }) => {
  if (!open) return null;

  return (
    <>
      {/* Backdrop */}
      <div
        onClick={onClose}
        style={{
          position: 'fixed', inset: 0, zIndex: 9998,
          background: 'rgba(0,0,0,0.15)', backdropFilter: 'blur(2px)',
        }}
      />

      {/* Dialog */}
      <div style={{
        position: 'fixed', top: '50%', left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '100%', maxWidth: 380, zIndex: 9999,
        background: 'var(--bg-surface, var(--bg-surface))',
        border: '1px solid var(--border-hover, rgba(0,0,0,0.08))',
        borderRadius: 'var(--radius-lg, 12px)',
        padding: '20px 24px',
        boxShadow: '0 24px 48px rgba(0,0,0,0.12)',
      }}>
        <div style={{
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          marginBottom: '16px',
        }}>
          <h3 style={{
            fontSize: '14px', fontWeight: 600,
            color: 'var(--text-primary, #F0F2F5)',
            margin: 0,
          }}>
            Keyboard Shortcuts
          </h3>
          <button
            onClick={onClose}
            style={{
              background: 'transparent', border: 'none',
              color: 'var(--text-muted, #64748B)', cursor: 'pointer',
              fontSize: '18px', padding: '0 4px',
            }}
          >
            &times;
          </button>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          {SHORTCUTS.map((s, i) => (
            <div
              key={i}
              style={{
                display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                padding: '4px 0',
              }}
            >
              <span style={{
                fontSize: '13px',
                color: 'var(--text-secondary, #94A3B8)',
              }}>
                {s.desc}
              </span>
              <div style={{ display: 'flex', gap: '4px' }}>
                {s.keys.map((k, j) => (
                  <React.Fragment key={j}>
                    {j > 0 && (
                      <span style={{ color: 'var(--text-hint, #475569)', fontSize: '11px', alignSelf: 'center' }}>
                        then
                      </span>
                    )}
                    <kbd style={{
                      fontSize: '11px', padding: '2px 8px', borderRadius: '4px',
                      background: 'var(--bg-elevated, var(--bg-elevated))',
                      color: 'var(--text-muted, #64748B)',
                      border: '1px solid var(--border-subtle, rgba(0,0,0,0.06))',
                      fontFamily: "var(--font-mono, var(--font-sans))",
                      minWidth: '24px', textAlign: 'center',
                    }}>
                      {k}
                    </kbd>
                  </React.Fragment>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default ShortcutsHelp;
